import { useCurrentUser } from '@/hooks/useAuth';

/**
 * Format an ISO timestamp in a given IANA timezone (falls back to the browser
 * zone when tz is empty/invalid). The server stores UTC; this renders it in the
 * user's chosen zone.
 */
export function formatDateTime(iso: string | Date | null | undefined, tz?: string | null): string {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
      ...(tz ? { timeZone: tz } : {}),
    }).format(d);
  } catch {
    return d.toLocaleString();
  }
}

/** Hook that returns a formatter bound to the current user's timezone preference. */
export function useFormatDateTime(): (iso: string | Date | null | undefined) => string {
  const { data: user } = useCurrentUser();
  const tz = user?.timezone ?? undefined;
  return (iso) => formatDateTime(iso, tz);
}
